import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/mypage-header.svg'
import _imports_1 from '../assets/detail.svg'


const _hoisted_1 = { class: "mypage" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "account_name" }
const _hoisted_4 = { class: "mypage__list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mypage__list" }
const _hoisted_7 = ["onClick"]

import { UNUSER, USER } from "../consts/common";
import { UserInfoStore } from "../store/UserInfoStore";
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";

const guest = "ゲスト";

export default /*@__PURE__*/_defineComponent({
  __name: 'MyPage',
  setup(__props) {

const router = useRouter();
const userInfoStore = UserInfoStore();
document.title = "マイページ";
const name = ref("");

// const isUser = ref(0);

onBeforeMount(async () => {
  // トークンがあればアカウント登録済み
  // if (omistore.userDetail.user_state == USER) {
  //   isUser.value = 1;
  // }
  if (!userInfoStore.userDetail.id) {
    await userInfoStore.getUserDetail().then(() => {
      name.value = userInfoStore.userDetail.name;
      return;
    });
  } else if (!userInfoStore.bankInfo.id) {
    await userInfoStore.getBankInfo();
  }
  if (userInfoStore.addressInfo.id < 0) {
    await userInfoStore.getAddressInfo();
  }
  name.value = userInfoStore.userDetail.name;
});

// ページ遷移
function push(page: string) {
  if (page == "/policy") {
    window.open("https://fisminc.com/privacy-policy/");
  } else {
    router.push(page);
  }
}
// ユーザーとゲストで出すメニューをフィルターかける
//  どちらでも出す2
function filterAccountItemList() {
  return accountItemList().filter(
    (v) => v.isUser == userInfoStore.userDetail.user_state
  );
}

// ユーザーとゲストで出すメニューをフィルターかける
// どちらでも出す2
function filterOtherItemList() {
  return otherItemList.filter(
    (v) => v.isUser == userInfoStore.userDetail.user_state || v.isUser == 2
  );
}

function accountItemList() {
  return [
    { name: "新規登録", page: "/sign-up", isUser: UNUSER },
    { name: "プロフィール", page: "/account-detail", isUser: USER },
    { name: "SNSアカウント登録", page: "/sns-accounts", isUser: USER },
    {
      name: "振込先銀行口座情報",
      page: userInfoStore.bankInfo.id ? "/bank-detail" : "/bank",
      isUser: USER,
    },
    {
      name: "配送先住所情報",
      page:  userInfoStore.addressInfo.id > 0 ? "/address-detail" : "/address",
      isUser: USER,
    },
    { name: "三条書面一覧", page: "/documents", isUser: USER },
    { name: "支払い通知書一覧", page: "/user-payment-transfers", isUser: USER },
  ];
}

const otherItemList = [
  // TODO 内容確認中のため一旦非表示
  // { name: "FAQ・お問い合わせ", page: "/faq", isUser: 2 },
  { name: "利用規約", page: "/terms-of-use", isUser: 2 },
  { name: "プライバシーポリシー", page: "/policy", isUser: 2 },
  { name: "退会", page: "/withdrawal", isUser: USER },
];
// }
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" マイページ "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, "アカウント名： " + _toDisplayString(_unref(userInfoStore).userDetail.name || guest) + "様", 1 /* TEXT */)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          inline: "",
          src: _imports_0
        }, null, -1 /* HOISTED */))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "list__title" }, [
          _createElementVNode("p", { class: "LinkList__Text" }, "アカウント情報")
        ], -1 /* HOISTED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterAccountItemList(), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (push(item.page)),
            class: "list__item"
          }, [
            _createElementVNode("p", null, _toDisplayString(item.name), 1 /* TEXT */),
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              class: "detail_icon",
              src: _imports_1,
              align: "right"
            }, null, -1 /* HOISTED */))
          ], 8 /* PROPS */, _hoisted_5))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "list__title" }, [
          _createElementVNode("p", { class: "LinkList__Text" }, "その他")
        ], -1 /* HOISTED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOtherItemList(), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (push(item.page)),
            class: "list__item"
          }, [
            _createElementVNode("p", null, _toDisplayString(item.name), 1 /* TEXT */),
            _cache[3] || (_cache[3] = _createElementVNode("img", {
              class: "detail_icon",
              src: _imports_1,
              align: "right"
            }, null, -1 /* HOISTED */))
          ], 8 /* PROPS */, _hoisted_7))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})